<template>
  <UIInputText
    v-model="modelValue"
    :data-refid="dataRefid"
    :label
    :disabled
    :error
    :silent
    :size
  />
</template>

<script setup lang="ts">
import { computed, inject, ref } from 'vue'

import { CashFlowProjectionClass } from '..'
import { InputSize } from '@types'

import { CASHFLOW_PROJECTION_FIELD } from '../utils/const'

import { UIInputText } from '@ui/fields'

type Props = {
  dataRefid?: string
  disabled?: boolean
  instance: CashFlowProjectionClass
  label?: string
  size?: InputSize
}

const props = defineProps<Props>()

const modelValue = props.instance.field<string>(CASHFLOW_PROJECTION_FIELD.DESCRIPTION)

const isSavedCashFlowProjection = inject('isSavedCashFlowProjection', ref(false))

const error = computed(() => props.instance.errors.description)
const silent = computed(() => !isSavedCashFlowProjection.value)
</script>
